exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8c4abfda] .el-table .cell{padding-right:0}[data-v-8c4abfda] .el-textarea__inner{width:92%}\n", ""]);

// exports
